import { CIcon } from '~/icons/types'
export const ciTownhomes: CIcon = {
  width: 1020,
  height: 1000,
  paths: [
    {
      d:
        'M981 944h-32V360q0-7-4.5-12t-12.5-5H433l-66-36q-2-2-7-2t-10 2l-150 80v-87q0-6-5-11.5t-12-5.5H85q-7 0-12 5t-5 12v157l-49 28q-5 3-7 9t1 10l30 79q4 8 8 8h6q5 0 9-2l6-4v357H17q-7 0-12 4.5t-5 12T4.5 971t12.5 5h966q7 0 12-5t5-12q-7-15-19-15zm-66-569v184H679l22-55q3-13-7-19L490 375h425zm-813-58h66v87l-66 37V317zm403 627H363V680h142v264zm107 0h-75V663q0-7-4.5-12t-12.5-5H346q-6 0-11.5 5t-5.5 12v281H106V570l253-136 253 136v374zM365 400q-2-2-7.5-2t-9.5 2L66 553l-17-47 308-167 308 167-17 47zm552 544H643V587l7 4q2 2 8 2h259v351zM282 649H166q-7 0-12 4.5t-5 12.5v97q0 7 4.5 12t12.5 5h116q7 0 12-4.5t5-12.5v-97q-3-17-17-17zm-17 97h-84v-66h84v66zM204 99v-7q0-27-20-47.5T136.5 24t-48 20T68 92v7q-32 20-32 49.5T68 196q0 26 21 47 4 4 10.5 4t11-4.5T115 231t-5-11q-10-12-10-26v-4q0-12-10-16.5t-16-12-6-13.5q0-16 23-28 12-7 9-19-2-4-2-11 0-14 11-25t25-11 25 11 11 25q0 7-2 11-3 12 8 19 11 4 17.5 12t6.5 15-6.5 14.5T176 173q-4 1-7 6.5t-1 10.5v4q0 15-9 24-4 15 5 23 4 4 11 3.5t12-5.5q14-14 17-43 15-9 23.5-21.5T236 148q0-31-32-49z',
      fill: 'currentColor'
    }
  ],
  name: 'townhomes',
  type: 'light'
}
